import { useState } from "react";
import DisplayConditions from "./DisplayConditions";
import Toast from "../Toast";
import { useLayoutStatus } from "../LayoutStatusContext";
import { __ } from '@wordpress/i18n'

export default function MoreOptions( props ) {

    const { postID, postLink, index, layout, layoutStatus, postStatus } = props;

    const isTemplatePublished = "publish" === postStatus;

      // State vars for Display Conditions modal.
    const [displayDUCTargetId, setDUCTargetId] = useState(null);
    const openDUCModal                         = (id) => setDUCTargetId(id);
    const closeDUCModal                        = () => setDUCTargetId(null);

    const { getStatus, updateStatus }          = useLayoutStatus();
    const [toast, setToast]                    = useState(null);

    const showToast = (message, type = 'success') => {
        setToast({ message, type });
    };
    
    const handleCopytoClipboard = (id) => {
        const text = `[responsive-site-builder id="${id}"]`;
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(text)
            .then(() => {
                showToast('Shortcode Copied to Clipboard!');
            })
            .catch(err => {
                showToast('Failed to Copy Shortcode!', 'error');
            });
        } else {
            // Fallback code for sites not supporting clipboard copy.
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();

            try {
                document.execCommand('copy');
                showToast('Shortcode Copied to Clipboard!');
            } catch (err) {
                showToast('Failed to Copy Shortcode!', 'error');
            }
            document.body.removeChild(textarea);
        }
    };

    const handleEnableDisable = async (index) => {
        const currentLayout = layout[index];
        const newStatus     = !getStatus(currentLayout.ID, currentLayout.layout_status);
        
        try {
        // Optimistically update the status
        updateStatus(currentLayout.ID, newStatus ? 'disabled' : 'enabled');

        const response = await fetch(
            responsive_addons_site_builder.rest_url + 'site-builder-layout-status',
            {
                method: "POST",
                headers: {
                    "X-WP-Nonce": responsive_addons_site_builder.nonce,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    layout_id: currentLayout.ID,
                    status: newStatus ? 'disabled' : 'enabled',
                }),
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        await response.json();
        } catch (err) {
            console.error("Failed to update layout status:", err);
            // Revert if API call fails
            updateStatus(currentLayout.ID, newStatus ? 'enabled' : 'disabled');
        }
    };

    return (
        <div
            className="text-xs absolute z-50 bg-white w-[138px] rounded-md top-14 right-6 border border-border shadow-[0px_10px_15px_0px_#00000014]"
            onClick={(e) => e.stopPropagation()}
        >
            <button onClick={() => handleEnableDisable(index)} className={`moreOptionsBtn hover:rounded-t-md  border-b border-gray-200 ${ ! isTemplatePublished ? 'cursor-not-allowed' : '' }`} disabled={!isTemplatePublished}>
            {getStatus(postID, layoutStatus) ? __("Enable", "responsive-addons") : __("Disable", "responsive-addons")}
            </button>
            <button onClick={() => window.open( postLink, "_blank" )} className="moreOptionsBtn border-b border-gray-200">
            {__("Preview", "responsive-addons")}
            </button>
            <button onClick={() => handleCopytoClipboard(postID)} className="moreOptionsBtn border-b border-gray-200">
            {__("Copy Shortcode", "responsive-addons")}
            </button>
            {toast && (
            <Toast
                message={toast.message}
                type={toast.type}
                onClose={() => setToast(null)}
            />
            )}
            <button className="moreOptionsBtn hover:rounded-b-md" onClick={()=> openDUCModal(postID)}>
            {__("Display Conditions", "responsive-addons")}
            </button>

            { displayDUCTargetId && <DisplayConditions closeModal={closeDUCModal} postID={displayDUCTargetId} /> }
        </div>
    )
}